import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.iconName = "share-twitter";
config.viewBox="0 0 31 31";
config.shape = `
    <g fill="var(--fill)" fill-rule="evenodd">
        <path fill="var(--fill-path1)" d="M15.777.675c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15z"/>
        <path fill="var(--fill-path2)" d="M24.227 10.677a7.273 7.273 0 0 1-1.993.518c.718-.414 1.276-1.062 1.515-1.838-.664.388-1.408.647-2.205.802-.611-.647-1.515-1.035-2.525-1.035-1.913 0-3.454 1.475-3.454 3.314 0 .26.026.492.08.751-2.87-.156-5.448-1.45-7.149-3.47a3.26 3.26 0 0 0-.478 1.657c0 1.165.612 2.176 1.541 2.77a4.014 4.014 0 0 1-1.567-.413v.026c0 1.605 1.196 2.951 2.79 3.262a3.649 3.649 0 0 1-.93.103c-.213 0-.425-.025-.638-.05.452 1.32 1.728 2.277 3.242 2.303a7.227 7.227 0 0 1-4.305 1.399c-.293 0-.558 0-.824-.026 1.515.932 3.348 1.476 5.314 1.476 6.378 0 9.859-5.05 9.859-9.426v-.414a7.117 7.117 0 0 0 1.727-1.709"/>
    </g>
`;
let ShareTwitterSVG = new SvgFactory(config);

export default ShareTwitterSVG;


